// src/components/About/index.tsx
import React from 'react';
import Container from 'react-bootstrap/Container';

const About: React.FC = () => {
    return (
        <Container>
            <h3>About Me</h3>
            <p>
                I like basketball <span role="img" aria-label="basketball">🏀</span>, noodle soups <span role="img" aria-label="noodles">🍜</span>, and traveling the world <span role="img" aria-label="noodles">✈️</span>.
            </p>
        </Container>
    );
};

export default About;

